import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import { I18n } from 'aws-amplify/utils'
import { useEffect } from 'react'
import { useGlobalContext } from '../../providers/global-provider/use-global-context'

import { components } from '../../utils/amplify-components'
import { formFields } from '../../utils/amplify-form-fields'
import { services } from '../../utils/amplify-parts'
import { Header } from '../header'
import { dictionary } from '../internationalization/dictionary'
import s from './app.module.css'
import StyledAuthenticator from './styled-authenticator'

interface Props {
  children?: React.ReactNode
}

const App: React.FC<Props> = props => {

  const { state } = useGlobalContext()

  useEffect(() => {
    // Configure the app only once on load.
    I18n.putVocabularies(dictionary)
    I18n.setLanguage(state.langtag)
  }, [])

  // Re-renders the entire app on language change.
  useEffect(() => {
    I18n.setLanguage(state.langtag)
  }, [state.langtag])

  const children = <div className={s.app}>
    <Authenticator.Provider>
      <Header />
      {props.children}
    </Authenticator.Provider>
  </div>


  return state.requireAuthenticator
    ? <StyledAuthenticator
      services={services}
      components={components}
      formFields={formFields}
      initialState={state.initialState}>
      {children}
    </StyledAuthenticator >
    : <>{children}</>
}

export default App
